import logo from "../../assets/images/logo.png";

const Logo = () => <img src={logo} alt="" />;

export default Logo;
